export function initMagneticButtons() {
  document.querySelectorAll('.mj-btn--magnetic').forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var dx = e.clientX - (rect.left + rect.width / 2);
      var dy = e.clientY - (rect.top + rect.height / 2);
      btn.style.transform = 'translate(' + dx * 0.25 + 'px, ' + dy * 0.25 + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = 'translate(0, 0)';
    });
  });
}

export function initClipReveals() {
  var subClips = document.querySelectorAll('.mj-hero-page .mj-clip__inner');
  if (!subClips.length || !('IntersectionObserver' in window)) return;

  var clipObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        clipObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  subClips.forEach(function (c) { clipObs.observe(c); });
}

export function initStaggerGrids() {
  var staggerGrids = document.querySelectorAll('.mj-stagger-grid');
  if (!staggerGrids.length) return;

  var gridObs = null;
  if ('IntersectionObserver' in window) {
    gridObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          gridObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
  }

  staggerGrids.forEach(function (g) {
    // ブログ一覧ページではスクロール連動なしで最初から表示
    if (g.closest('.mj-blog-page')) {
      g.classList.add('is-visible');
      return;
    }
    if (gridObs) gridObs.observe(g);
  });
}

export function initDividers() {
  var dividers = document.querySelectorAll('.mj-divider');
  if (!dividers.length || !('IntersectionObserver' in window)) return;

  var divObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        divObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  dividers.forEach(function (d) { divObs.observe(d); });
}

export function initLectureCards() {
  document.querySelectorAll('.mj-lecture-card__details').forEach(function (details) {
    var toggleEl = details.querySelector('.mj-lecture-card__toggle-text');
    if (!toggleEl) return;
    var openLabel = toggleEl.getAttribute('data-open-label') || '\u9589\u3058\u308b';
    var closedLabel = toggleEl.getAttribute('data-closed-label') || '\u8a73\u7d30\u3092\u898b\u308b';
    var update = function () {
      toggleEl.textContent = details.open ? openLabel : closedLabel;
    };
    update();
    details.addEventListener('toggle', update);
  });
}
